// Keeps a partner code in this browser while a learner with an existing account
// logs in, so it can be redeemed on the next signed-in page.
export const PARTNER_CODE_QUERYPARAM = 'learnModeCode';

const STORAGE_KEY = 'enki:pending-partner-code';

export function rememberPendingPartnerCode(code: string) {
  try {
    window.localStorage.setItem(STORAGE_KEY, code);
  } catch {
    // Storage unavailable.
  }
}

export function readPendingPartnerCode(): string | null {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function forgetPendingPartnerCode() {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Storage unavailable.
  }
}
